export default __webpack_public_path__ + "static/officework-bg-b53d33daf1b51ecbaa28ee36775f440c.webp";